import HTTPService from '../HTTPService'

class InternalComment {
  add (companySlug, clientId, payload) {
    return HTTPService.post(`company/${companySlug}/client/${clientId}/internal-comment`, {
      comment: payload.comment
    })
  }
}

export default new InternalComment()
